
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { blue } from '@material-ui/core/colors';

import CloseIcon from 'img/white-close-icon.svg';
import Airpods from 'img/airpods.png';

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  container: {
    padding: "30px"
  },
  closeBtn: {
    width: "20px",
    cursor: "pointer",
    position: "absolute",
    top: "15px",
    right: "15px"
  },
  airpods: {
    width: "100%"
  },
  buttonContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  submitButton: {
    maxWidth: "70%",
    width: "240px",
    margin: "3px auto !important"
  }
});

export default function GiveawayDialog(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
    localStorage.setItem("seen_modal", true);
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
      <div onClick={handleClose}><img alt="close" className={classes.closeBtn} src={CloseIcon} /></div>
      <img alt="airpods" src={Airpods} className={classes.airpods} />
      <div className={classes.container}>
        <Typography variant="h4" align="center" style={{ fontFamily: "Arvo" }}>Win Airpods Pro</Typography>
        <br />
        <Typography variant="body1" style={{ fontFamily: "Lato" }}>{`By submitting a verifiable remote-work policy, professional review, or other information you will be entered to win.`}</Typography>
        <br />
        <Typography variant="body1" style={{ fontFamily: "Lato" }}>1 in 100 submissions win.</Typography>
        <br />
        <div className={classes.buttonContainer}>
          <Button variant="outlined" className={classes.submitButton} style={{ margin: "auto" }} onClick={props.openPolicy}>Submit Company Policy</Button>
          <Button variant="outlined" className={classes.submitButton} style={{ margin: "auto" }} onClick={props.openReviews}>Submit Review</Button>
        </div>
      </div>
    </Dialog>
  );
}

GiveawayDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};
